export default __webpack_public_path__ + "static/media/pic_3.e43787cd.webp";